export default "__VITE_ASSET__s9TV2RUN__"